module.exports = __webpack_public_path__ + "img/7.49b0a8b2.jpg";